import { SportMatchModel } from '@nf/types/odds';
import { OddsButton } from '@/components/widgets/odds-button';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { Fragment } from 'react';
import { BetTypeContentProps } from '../bet-type-content';
import { getHomeTeamName, getTeamName } from '@/utils/odds-utils';
import { BetChoices } from '@/types/bet-type-settings';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeCol3GoalFromOptions = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const oddsData = useAtomValue(oddsPageAtom);
	const setting = getBetTypeSetting(betTypeArray[0].BetTypeId, matchModel.GameID);
	const betChoices = setting?.betChoices;
	const t = useTranslations('General');
	const betChoiceTranslate = useTranslations('Choice');
	const { user } = useAccountInfo();
	const homeTeamName = getHomeTeamName(matchModel?.TeamId1, matchModel.Neu, t('Neutral_Team'), oddsData?.teamNameMap);
	const awayTeamName = getTeamName(matchModel?.TeamId2, oddsData?.teamNameMap);

	const getBetChoiceName = (betTypeId: number, betTeam: string, label: string) => {
		let choiceName = label;

		if (setting?.betChoiceTranslateType === 'General') {
			const basketballSpecialBetType = [601, 602, 608, 614];
			if (basketballSpecialBetType.includes(betTypeId)) {
				const replaceValue = betTeam.substring(1);
				choiceName = t(label, { 0: replaceValue });
			} else {
				choiceName = t(label);
			}
		} else if (setting?.betChoiceTranslateType === 'Choice') {
			choiceName = betChoiceTranslate(label);
		}

		return choiceName;
	}

	const groupChoices = betChoices.sort((a, b) => {
		// 先依照betChoiceGroup排序
		return (a.betChoiceGroup ?? 0) - (b.betChoiceGroup ?? 0);
	}).reduce((groupChoices, choice) => {
		const existingGroup = groupChoices.find(choices => choices.some(targetChoice => targetChoice.betChoiceGroup == choice.betChoiceGroup));

		if (existingGroup) {
			existingGroup.push(choice);
		} else {
			groupChoices.push([choice]);
		}

		return groupChoices;
	}, new Array<Array<BetChoices>>());

	return (
		<div className="bettype__content bettype__content--col-3-goal">
			<div className="bettype__list">
				<div className="bettype__goal" />
				<div className="bettype__title">{homeTeamName}</div>
				<div className="bettype__title">{awayTeamName}</div>
			</div>
			{
				betTypeArray.map((market) => {
					return (
						<Fragment key={market.Line}>
							{
								groupChoices.map((choices) => {
									const className = choices.length % 2 === 1 ? 'bettype__list bettype__list--col-2' : 'bettype__list';
									return (
										<div key={choices[0].betChoiceGroup} className={className}>
											<div className="bettype__goal">{getBetChoiceName(market.BetTypeId, choices[0].betTeam, choices[0].label)}</div>
											{
												choices.map((choice) => {
													return (
														<OddsButton
															key={`${market.Line}_${choice.betTeam}`}
															match={matchModel as SportMatchModel}
															market={market}
															selection={market.Selections[choice.betTeam]}
															homeTeamName={homeTeamName}
															awayTeamName={awayTeamName}
															variant="default"
															betTeam={market.Selections[choice.betTeam].SelId}
															originalPrice={market.Selections[choice.betTeam].Price}
															sport={matchModel?.GameID}
															type="OU"
															oddsType={user?.OType}
															accountStatus={user?.ActStatus ?? 0}
														/>
													)
												})
											}
										</div>
									)
								})
							}
						</Fragment>
					)
				})
			}
		</div>
	)
};
